angular.module("censimentoUserAra.components", [])
    .component("censimentoUserAra", {
        templateUrl: 'ng/components/userManagementAra/censimentoUserAra/censimentoUserAra.view.html',
        bindings: {
            userTypes: "<?",
            userTypePending: "<?"
        },
        controller: CensimentoUserAraController,
        controllerAs: 'censimentoUserAraCtrl'
    })

function CensimentoUserAraController(
    $searchUserService
) {
    var self = this;

    self.$onInit = function () {
        self.userCensito = false;
    }

    self.censusAraObj = {
        typeUser: null,
        ndg: null,
        name: null,
        surname: null,
        email: null,
        tel: null
    }

    self.censusAra = function () {
        var censusAraObj = {
            type: self.censusAraObj.typeUser.value,
            ndg: self.censusAraObj.ndg,
            name: self.censusAraObj.name,
            surname: self.censusAraObj.surname,
            email: self.censusAraObj.email,
            tel: self.censusAraObj.tel
        }
        self.isLoading = true;
        $searchUserService
            .censimentoUser(censusAraObj)
            .then(function (response) {
                if (response.success) {
                    self.userCensito = response.username;
                    Object.keys(self.censusAraObj).forEach(function (e) {
                        self.censusAraObj[e] = '';
                    })
                }
            })
            .catch(function (err) {
                console.log(err)
            })
            .finally(function () {
                self.isLoading = false;
            })
    }

}